<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" style="width: 150px;" v-model="formInline.MemberName" :placeholder="this.$t('Model.Member.MemberName')">
				<span slot="prepend">{{ this.$t('Model.Member.MemberName') }}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 150px;" v-model="formInline.PhoneNo" :placeholder="this.$t('Model.Member.PhoneNo')">
				<span slot="prepend">{{ this.$t('Model.Member.PhoneNo') }}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 150px;" v-model="formInline.ChargeCardNo" :placeholder="this.$t('Model.Member.CardNo')">
				<span slot="prepend">{{ this.$t('Model.Member.CardNo') }}</span>
				</Input>
			</FormItem>
			<FormItem :label="this.$t('Individual.ChargingCardStatus')" :label-width="100" prop="trackName">
				<Select :placeholder="this.$t('Individual.ChargingCardStatus')" style="width: 120px;" v-model="formInline.Status">
					<Option :value='-1'>{{ this.$t('Common.All') }}</Option>
					<Option :value='0'>{{ 0 | MemberStatusDesc }}</Option>
					<Option :value='1'>{{ 1 | MemberStatusDesc }}</Option>
					<Option :value='256'>{{ 256 | MemberStatusDesc }}</Option>
					<Option :value='512'>{{ 512 | MemberStatusDesc }}</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">{{ this.$t('ChargeRecord.ExportFile') }}</Button>
			</FormItem>
			
		</Form>
		<Card class="card" style="margin-bottom: 20px;">
	
			<Row :gutter="20" class="summy">
				<Col span="12" class="text">{{ this.$t('Individual.TotalMembersCount') }}:<span class="value">{{memberSummy.MemberNum}}</span></Col>
				<Col span="12" class="text">{{ this.$t('Individual.TotalAccountBalance') }}:<span class="value">{{memberSummy.MemberBalance.toFixed(2)}}</span></Col>
			</Row>
		</Card>
		<Table class="tableExtend" :columns="columns1" :data="data1" :height="tableHeight" ref="tableData"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getMemberInfoUrl" @listData='getDeviceData'></MyPage>
		<Deposit ref="deposit" @upData="handleSubmit"> </Deposit>
		<Modal v-model="modal2.ifShow" :title="modal2.Title" width="40%" :mask-closable="false" :closable="false">
	
			<Form :rules="ruleInline" label-position="right" v-if="modal2.type=='add'||modal2.type=='up'"
				ref="chargeCardForm" :model="chargeCardInfo" :label-width="110">
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="this.$t('Model.Member.MemberId')" prop="GroupId">
						<Input :disabled="true" v-model="chargeCardInfo.GroupId" :placeholder="this.$t('Model.Member.MemberId')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="this.$t('Model.Member.CardNo')" prop="CardNo">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.CardNo" :placeholder="this.$t('Model.Member.CardNo')"></Input>
					</FormItem>
					</Col>
				</Row>
				
				<Row :gutter="24">
					
					<Col span=12>
					<FormItem prop="StationArray" :label="this.$t('Individual.RestrictedStations')">
						<Select :max-tag-count='1' :placeholder="this.$t('Individual.RestrictedStations')" multiple v-model="chargeCardInfo.StationArray">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in StationList"
								:value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="this.$t('Model.Member.CarNo')" prop="CarNo">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.CarNo" :placeholder="this.$t('Model.Member.CarNo')"></Input>
					</FormItem>
					</Col>
				</Row>
				
				<Row :gutter="24">
					<Col span=24>
					<FormItem :label="this.$t('Model.Member.Remarks')" prop="Remark">
						<Input :disabled="modal2.canInput" v-model="chargeCardInfo.Remark" :placeholder="this.$t('Model.Member.Remarks')"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal2.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk2('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk2('add')">{{ $t('Common.Add') }}</Button>
			</div>
			<div v-if="modal2.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk2('cancle')" size="large">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" @click="modalOk2('up')" size="large">{{ $t('Common.Edit') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './MemberInfoComponent/MemberInfoExpand.vue';
	import Deposit from './MemberInfoComponent/Deposit.vue';
	import { formatLocalTime } from "../../../utils/date"

	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			Deposit
		},
		data() {
			const validateStationArray = (rule, value, callback) => {
				if (value.length == 0) {
					callback(new Error(this.$t('Individual.PleaseSelectStation')));
				} else {
					callback();
				}
			};
			return {
				getMemberInfoUrl: webapi.base_api_url + '/Member/GetMemberInfo',
				memberSummy: {
					MemberNum: 0,
					MemberBalance: 0,
				},
			
				chargeCardInfo: {
					GroupId: '',
					CardNo: '',
					VerifyMode: 1,
					Password: '',
					CarNo: '',
					CarVin: '',
					StationList: '',
					Remark: '',
					StationArray: []
				},
				//model2 
				modal2: {
					Title: this.$t('Individual.AddChargingCard') ,
					type: "add",
					ifShow: false,
					canInput: false
				},
			
				ruleInline: {
					CardNo: [{
							required: true,
							message: this.$t('Individual.PleaseEnterNumber') ,
							trigger: 'blur',
						},
						// {
						// 	validator: usernameV,
						// 	trigger: 'blur'
						// }
					],
					StationArray: [{
						validator: validateStationArray,
						trigger: 'blur',
					}],
					CarNo: [{
						required: true,
						message:  this.$t('Individual.PleaseEnterCarNo') ,
						trigger: 'blur',
					}]
				},
	
				upHeader: {
					Authorization: "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				//
				tableHeight: "650",
				BreadcrumbList: [this.$t('memberCard') , '>>',this.$t('memberInfo')],
				formInline: {
					MemberName: '',
					PhoneNo: '',
					ChargeCardNo: '',
					Status: -1
				},
				//Table Title Data
				columns1: [{
						type: 'expand',
						width: 30,
						render: (h, params) => {
							const _this = this
							return h(expandRow, {
								props: {
									row: params.row
								},
								on: {
									// $emit
									upCard(GroupId, CardNo) {
										console.log(GroupId + "----" + CardNo)
										_this.openAddChargeCar("up", GroupId, CardNo);
									},
									upData(GroupId, CardNo) {
										_this.handleSubmit();
									},
								}
							})
						}
					},
			
					{
						title:  this.$t('Individual.MemberAvatar'),
						key: 'Headimgurl',
						minWidth: 80,
						render: (h, params) => {
							let arr = [];
							if (params.row.Headimgurl == ""||params.row.Headimgurl==undefined) {
								arr.push(h('div', this.$t('Individual.NotUploaded')))
							} else {
								arr.push(
								h('div', [
									h('img', {
										style: {
											width: "24px",
											height: "24px",
											verticalAlign: "middle",
											borderRadius: "50%"
										},
										attrs: {
											src: /http.*/i.test(params.row.Headimgurl) ? params.row.Headimgurl : webapi.base_api_url + params.row.Headimgurl
										}
									})
								])
								)
							}
							return arr;
				
						}
					},
					{
						title:this.$t('Model.Member.MemberName') ,
						key: 'MemberName',
						minWidth: 100,
					},
				
					{
						title: this.$t('Model.Member.PhoneNo'),
						key: 'PhoneNo',
						minWidth: 110,
					},
					{
						title: this.$t('Model.Member.Balance'),
						key: 'Account',
						minWidth: 80,
					},
					{
						title:  this.$t('Model.Member.RechargeAccount'),
						key: 'RechargeAccount',
						minWidth: 90,
					},
				
					{
						title: this.$t('Model.Member.MemberPoints'),
						key: 'MemberPoints',
						minWidth: 80,
					},
					{
						title: this.$t('Model.Member.TotalChargeCost') ,
						key: 'TotalChargeCost',
						minWidth:110,
					},
					{
						title: this.$t('Model.Member.TotalChargeTimes'),
						key: 'TotalChargeNum',
						minWidth: 110,
					},
					{
						title: this.$t('Model.Member.Recent30DaysChargingTimes'),
						key: 'RecentChargeNum',
						minWidth: 120,
					},
					{
						title: this.$t('Model.Member.LastChargeTime') ,
						key: 'LastChargeTime',
						minWidth: 150,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.LastChargeTime))
						}
					},
					
					{
						title: this.$t('Model.Member.Status'),
						key: 'State',
						minWidth: 80,
						render: (h, params) => {
							return h('div',
								this.$options.filters.MemberStatusDesc(params.row.State) 
							);
						}
					},
					
					{
						title: this.$t('Individual.RegistrationTime'),
						key: 'CreateTime',
						minWidth: 150,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.CreateTime))
						}
					},
			
					{
						title: this.$t('Common.Actions'),
						key: 'action',
						align: 'center',
						minWidth: 200,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('add') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.openAddChargeCar("add", params.row.MemberId)
										}
									}
								}, this.$t('Individual.AddElectricCard')) : h(),
								
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//To avoid incorrect operations, confirm and cancel should function oppositely.
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$t('Common.Cancel'),
													cancelText: this.$t('Common.Confirm'),
													onCancel: () => {
														this.otherMethod(name, params.row
															.MemberId);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										},
										props: {
											transfer: true,
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$t('Individual.Other')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
												item) => { 
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				methodList: [{
					name: 'blacklist',
					Status: this.$t('Individual.AddToBlacklist') 
				}, {
					name: 'unBlacklist',
					Status:  this.$t('Individual.RemoveFromBlacklist') 
				}],
				data1: []
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 300;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			VerifyMode1: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 1;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 1;
					}
				}
			},
			VerifyMode2: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 2;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 2;
					}
				}
			},
			VerifyMode3: {
				get() {
					let pay = this.chargeCardInfo.VerifyMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(3, 4))
				},
				set(value) {
					if (value == 0) {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode - 4;
					} else {
						this.chargeCardInfo.VerifyMode = this.chargeCardInfo.VerifyMode + 4;
					}
				}
			},
		
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: this.$t('Individual.MemberInformation') ,
					columns: this.columns1,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.State = k.StateDesc;
						return k;
					})
				})
			},
			show: function(type, param) {
				switch (type) {
					case "deposit":
						this.$refs.deposit.openRechargeForCard(param, '')
						break
				}
			},
	
			otherMethod: function(type, MemberId) {
				const _this = this;
				let status = ''
				switch (type) {
					case this.$t('Individual.AddToBlacklist') :
						status = 1024
						break;
					case this.$t('Individual.RemoveFromBlacklist') :
						status = 0
						break;
				}
				let parms = {
					Id: MemberId,
					Status: status
				};
				_this.$axios.post(webapi.base_api_url + "/Member/SetMemberStatus ", parms, {}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.handleSubmit()
					} else {
						_this.$Message.error(this.$t('Common.OperationFailed'));
					}
				})
			},
			
			openAddChargeCar: function(type, memberId, CardNo) {
				const _this = this;
				if (type == "add") {
					_this.modal2.Title =this.$t('Individual.AddChargingCard') ;
					_this.modal2.type = "add";
					_this.$refs.chargeCardForm.resetFields()
					_this.chargeCardInfo.GroupId = memberId
				} else if (type == "up") {
					
					_this.modal2.Title =this.$t('Individual.ModifyChargingCard') ;
					_this.modal2.type = "up";
					let upMember = _this.data1.filter((item) => {
						return item.MemberId == memberId
					})
					let upMemberCard = upMember[0].ChargeCards.filter((item) => {
						return item.CardNo == CardNo
					})
					_this.chargeCardInfo = {
						GroupId: upMemberCard[0].GroupId,
						CardNo: upMemberCard[0].CardNo,
						VerifyMode: upMemberCard[0].VerifyMode,
						Password: upMemberCard[0].Password,
						CarNo: upMemberCard[0].CarNo,
						CarVin: upMemberCard[0].CarVin,
						StationArray: upMemberCard[0].StationArray,
						Remark: upMemberCard[0].Remark,
					};
				}
				_this.modal2.ifShow = true
			},
			//model2
			modalOk2: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal2.ifShow = false
						break;
					case 'add':
						_this.modal2.ifShow = true
						_this.addCard();
						break;
					case 'up':
						_this.modal2.ifShow = true
						_this.upCard();
						break;
					default:
						break;
				}
			},
		
			addCard: function() {
				const _this = this;
				_this.$refs.chargeCardForm.validate((valid) => {
					if (valid) {
						_this.chargeCardInfo.StationList = JSON.stringify(_this.chargeCardInfo.StationArray)
						let parms = _this.chargeCardInfo
						_this.$axios.post(webapi.base_api_url + "/Member/AddChargeCard", parms, {}).then(
							res => {
								console.log("add car")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success(this.$t('Common.OperationSuccess'));
									_this.handleSubmit();
									_this.modalOk2("cancle")
								} else {
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
			
			upCard: function() {
				const _this = this;
				let parms = _this.chargeCardInfo
				_this.$axios.post(webapi.base_api_url + "/Member/ModifyChargeCard", parms, {}).then(res => {
					console.log("edit car")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.OperationSuccess'));
						_this.handleSubmit();
						_this.modalOk2("cancle")
					} else {
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Member/GetMemberSummy ", _this.formInline, {}).then(
					res => {
						if (res.data.Code == 0) {
		
							_this.memberSummy = res.data.Data;
						} else {
							_this.$Message.error(this.$t('Common.Failed'));
						}
					}).catch(err => {
						_this.$Message.error(this.$t('Common.Failed'));
				});
				
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 290 - (window.innerWidth < 1087 ? 60 : 0);
			}
		},
	}
</script>

<style scoped>
	#app {
		text-align: left;
	}
	
	.tableExtend td.ivu-table-expanded-cell {
		padding: 1px 60px;
		background: #f8f8f9;
	}

	.memberStyle .ivu-avatar-large {
		width: 100px;
		height: 100px;
		line-height: 40px;
		border-radius: 50px;
	}
	
	.summy .text,
	.card .text {
		font-size: 16px;
	}
	
	.card .value {
		font-size: 18px;
		/* color: royalblue; */
	}
</style>
